import { eventNames, useCoreEvents } from '@carvana/core-events';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext } from 'react';
import sendFavoriteMessageToNative from '@/srp/VehicleTile/sendFavoriteMessageToNative';
import UserContext from '~/context/common/UserContext';
import { addFavorite as addFavoriteApi } from '~/services/common';
import { AddFavoriteRequestBody } from '~/services/common/addFavorite';
import { generateErrorLogger } from '~/utilities/loggers';

// This hook is mainly for just adding a favorite and example use case is the WipNotificationModal(srp only atm) to add a favorite from the modal.
// I would refer to the useAddFavoriteFlow if trying to implement the toggle flow example in the VehicleTile component.
export default function useAddFavoriteWithoutLogin() {
  const {
    favorites: { setLoading, setData, setError }
  } = useContext(UserContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { emit } = useCoreEvents();

  return useCallback(
    async (payload: AddFavoriteRequestBody) => {
      setLoading();
      try {
        const { data: vehicles } = await addFavoriteApi(payload);
        setData(vehicles);

        trackEvent('favorite added', { vehicleId: payload.vehicleId });
        sendFavoriteMessageToNative('add', { vehicleId: payload.vehicleId });
        emit(eventNames.favorites.mfe.refresh, { source: 'app', vehicles });
      } catch (err) {
        generateErrorLogger('add favorite vehicle', {}, { callback: setError });
      }
    },
    [emit, setData, setError, setLoading, trackEvent]
  );
}
